import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ShipmentFilters = ({ filters, onFilterChange, onReset, onExportCSV, resultsCount }) => {
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  // Count active filters
  const activeFiltersCount = Object.entries(filters)?.filter(([key, value]) => {
    if (key === 'search' || key === 'city' || key === 'startDate' || key === 'endDate') {
      return value !== '';
    }
    return value !== 'all';
  })?.length;

  return (
    <div className="bg-white rounded-lg shadow-sm mb-6 overflow-hidden">
      {/* Mobile Filter Accordion Header */}
      <button
        onClick={() => setIsFiltersOpen(!isFiltersOpen)}
        className="md:hidden w-full flex items-center justify-between px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center space-x-2">
          <span className="text-sm font-medium text-gray-800">Filtrer</span>
          {activeFiltersCount > 0 && (
            <span className="bg-green-600 text-white text-xs font-medium px-2 py-1 rounded-full">
              {activeFiltersCount}
            </span>
          )}
        </div>
        {isFiltersOpen ? (
          <ChevronUp size={20} className="text-gray-600" />
        ) : (
          <ChevronDown size={20} className="text-gray-600" />
        )}
      </button>

      {/* Filters Content - Accordion on mobile, always visible on desktop */}
      <div className={`${isFiltersOpen ? 'block' : 'hidden'} md:block p-4 md:p-6`}>
        {/* Filter Grid - Single column on mobile, multi-column on desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-4">
          {/* Search */}
          <div className="w-full min-w-0">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Rechercher
            </label>
            <Input
              type="text"
              placeholder="Référence, expéditeur..."
              value={filters?.search}
              onChange={(e) => onFilterChange('search', e?.target?.value)}
              className="w-full"
            />
          </div>

          {/* Status Filter */}
          <div className="w-full min-w-0">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Statut
            </label>
            <select
              value={filters?.status}
              onChange={(e) => onFilterChange('status', e?.target?.value)}
              className="w-full min-w-0 px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
              <option value="all">Tous les statuts</option>
              <option value="en_attente">En attente</option>
              <option value="depose">Déposé</option>
              <option value="en_preparation">En préparation</option>
              <option value="stocke">Stocké</option>
              <option value="charge_conteneur">Chargé conteneur</option>
              <option value="au_port_anvers">Port Anvers</option>
              <option value="bateau_parti">Bateau parti</option>
              <option value="bateau_en_mer">En mer</option>
              <option value="en_transit">En transit</option>
              <option value="arrive_abidjan">Arrivé Abidjan</option>
              <option value="douane">Douane</option>
              <option value="en_livraison">En livraison</option>
              <option value="livre">Livré</option>
              <option value="annule">Annulé</option>
              <option value="delivered">Livré (ancien)</option>
              <option value="exception">Exception</option>
            </select>
          </div>

          {/* City Filter */}
          <div className="w-full min-w-0">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Ville
            </label>
            <Input
              type="text"
              placeholder="Abidjan, Yopougon..."
              value={filters?.city}
              onChange={(e) => onFilterChange('city', e?.target?.value)}
              className="w-full"
            />
          </div>

          {/* Start Date Filter */}
          <div className="w-full min-w-0">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Du
            </label>
            <Input
              type="date"
              value={filters?.startDate}
              onChange={(e) => onFilterChange('startDate', e?.target?.value)}
              className="w-full"
            />
          </div>

          {/* End Date Filter */}
          <div className="w-full min-w-0">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Au
            </label>
            <Input
              type="date"
              value={filters?.endDate}
              onChange={(e) => onFilterChange('endDate', e?.target?.value)}
              className="w-full"
            />
          </div>
        </div>

        {/* Actions Row - Stacked on mobile, horizontal on desktop */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center space-y-3 md:space-y-0 gap-2">
          <div className="text-sm text-gray-600">
            {resultsCount} envoi(s) trouvé(s)
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={onReset}
              className="flex-1 md:flex-none px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors flex items-center justify-center space-x-2"
            >
              <Icon name="RotateCcw" size={16} />
              <span>Réinitialiser</span>
            </button>
            <button
              onClick={onExportCSV}
              className="flex-1 md:flex-none px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors flex items-center justify-center space-x-2"
            >
              <Icon name="Download" size={16} />
              <span>Exporter CSV</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShipmentFilters;